import React from 'react';
import styled from 'styled-components';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LoadingContainer = styled.div`
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  color: #4b5563;
`;

const ProtectedRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, hasRole, loading } = useAuth();

  if (loading) {
    return (
      <LoadingContainer>
        Loading your workspace...
      </LoadingContainer>
    );
  }

  // If user is not authenticated, redirect to login
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // If roles are specified, check if user has any of the required roles
  if (roles.length > 0 && !roles.some(role => hasRole(role))) {
    // User doesn't have the required role, redirect to home or unauthorized page
    return <Navigate to="/unauthorized" replace />;
  }

  // If user is authenticated and has the required role, render the children
  return children;
};

export default ProtectedRoute;
